import React, { Fragment } from 'react'
import { Col, Button, Table, Label } from 'react-bootstrap'
import '../style.css'

const SAPResource = (props) => {
	const { resource } = props

	const handleDocumentClick = (documentUrl) => {
		let win = window.open(documentUrl, '_blank, noopener, noreferrer')
		win.focus()
	}

	const createdBy = resource.created_by ? `${resource.created_by.first_name} ${resource.created_by.last_name}` : 'N/A'
	const createdById = resource.created_by ? resource.created_by.id : null

	let formatedDate = 'N/A'
	if (resource.created_date) {
		const postedDate = resource.created_date.split("T")[0].split("-")
		formatedDate = `${postedDate[1]}-${postedDate[2]}-${postedDate[0]}`
	}

	let sapOrProtocol = 'N/A'
	if (resource.is_protocol && resource.is_sap) {
		sapOrProtocol = 'Both'
	} else if (resource.is_protocol) {
			sapOrProtocol = 'Protocol'
	} else if (resource.is_sap) {
			sapOrProtocol = 'SAP'
	}

	return (
		<Fragment>
			<Col xsHidden smHidden mdHidden lg={1} xl={1}></Col>
			<Col xs={12} sm={12} md={12} lg={10} xl={10} id="post-content">
				<Table>
					<tbody>
						<tr>
							<td className="title-field">
								Title
							</td>
							<td>
								{resource.title}
							</td>
						</tr>

						<tr>
							<td className="title-field">
								PTOR ID
							</td>
							<td>
								{resource.project}
							</td>
						</tr>

						<tr>
							<td className="title-field">
								Project Folder Path
							</td>
							<td>
								{resource.project_folder_path}
							</td>
						</tr>

						<tr>
							<td className="title-field">
								Posted on
							</td>
							<td>
								{formatedDate}
							</td>
						</tr>

						<tr>
							<td className="title-field">
								Posted by
							</td>
							<td>
								<span
									className={createdById === props.currentUser.pk ? "current-user" : null}
								>
									{createdBy}
								</span>
							</td>
						</tr>

						<tr>
							<td className="title-field">
								Authors
							</td>
							<td>
								{Array.isArray(resource.authors) ?
									resource.authors.map(author => `${author.first_name} ${author.last_name}`).join(', ')
									:
									'N/A'
								}
							</td>
						</tr>

						<tr>
							<td className="title-field">
								SAP or Protocol?
							</td>
							<td>
								{sapOrProtocol}
							</td>
						</tr>

						<tr>
							<td className="title-field">
								External Client
							</td>
							<td>
								{resource.external_client ?
									`${resource.external_client.name} ${resource.external_client.short_code}`
									:
									'N/A'
								}
							</td>
						</tr>

						<tr>
							<td className="title-field">
								Therapeutic Areas
							</td>
							<td>
								{resource.therapeutic_areas.map(therapeutic_area => (
									<span key={therapeutic_area.id} style={{ fontSize: '14pt', margin: '0 5px' }}>
										<Label bsStyle="danger">
											{therapeutic_area.name}
										</Label>
									</span>
								))}
							</td>
						</tr>

						<tr>
							<td className="title-field">
								Designs
							</td>
							<td>
								{resource.designs.map(design => (
									<span key={design.id} style={{ fontSize: '14pt', margin: '0 5px' }}>
										<Label bsStyle="info">
											{design.name}
										</Label>
									</span>
								))}
							</td>
						</tr>

						<tr>
							<td className="title-field">
								Data Sources
							</td>
							<td>
								{resource.data_sources.map(data_source => (
									<span key={data_source.id} style={{ fontSize: '14pt', margin: '0 5px' }}>
										<Label bsStyle="success">
											{data_source.name}
										</Label>
									</span>
								))}
							</td>
						</tr>

						<tr>
							<td className="title-field">
								Methods
							</td>
							<td>
								{resource.methods.map(method => (
									<span key={method.id} style={{ fontSize: '14pt', margin: '0 5px' }}>
										<Label bsStyle="warning">
											{method.name}
										</Label>
									</span>
								))}
							</td>
						</tr>

						<tr>
							<td className="title-field">
								Content
							</td>
							<td>
								{resource.contents.map(content => (
									<span key={content.id} style={{ fontSize: '14pt', margin: '0 5px' }}>
										<Label bsStyle="primary">
											{content.name}
										</Label>
									</span>
								))}
							</td>
						</tr>
					</tbody>
				</Table>

				{resource.text ?
					<Fragment>
						<h4>
							Notes
						</h4>

						<hr />
						<div
							className="post-content-div"
							dangerouslySetInnerHTML={{ __html: resource.text }}
						>
						</div>
						<hr />
					</Fragment>
					:
					null
				}


				{resource.documents.length > 0 ?
					<Fragment>
						<h4>Attached Documents</h4>
						{resource.documents.map(doc => {
							return (
								<div className="document-button" key={doc.id}>
									<Button onClick={() => handleDocumentClick(doc.document)}>
										{doc.name}
									</Button>
								</div>
							)
						})}
					</Fragment>
					:
					null
				}
			</Col>
		</Fragment>
	)
}

export default SAPResource



// WEBPACK FOOTER //
// ./src/routes/sap-resources/components/SAPResource.js